import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Broadcast from './icon-broadcast.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Broadcast {...validProps} />;
}
SvgComponent.iconName = 'broadcast';

/**
 * @deprecated This is a legacy icon
 */
export const BroadcastIcon = svgIconWrapper(SvgComponent);
